import { render, staticRenderFns } from "./usage_billing_forbidden_banner.vue?vue&type=template&id=0ddd2230"
import script from "./usage_billing_forbidden_banner.vue?vue&type=script&lang=js"
export * from "./usage_billing_forbidden_banner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports